import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { Location } from 'history';
import b from 'b_';

import './events-page.css';

import Breadcrumbs from '@components/breadcrumbs';
import PageMeta from '@components/page-meta';
import PaginationMeta from '@interfaces/pagination-meta';
import { PaginationWrapperProps } from '@components/pagination-wrapper';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import { Event } from '@interfaces/outreach-entity';
import EventItem from '@components/event-item';
import ShowMore from '@components/pagination-wrapper/show-more';
import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';
import { formatQuery, parseQuery } from 'client/helpers/url';
import { fetchEvents, fetchEventsFilters } from 'client/ducks/events-page/actions';
import EventsPageStub from 'pages/events-page/events-page.stub';
import YearFilter from '@components/year-filter/year-filter';

import outreachConfig from '../outreach/page-config.json';

export interface DispatchProps {
    fetchEvents(params: OutreachRequestParams): void;
    fetchFilters(): void;
}

interface StateProps {
    hasMore: boolean;
    years: number[];
    rows: Event[];
    meta: PaginationMeta;
    listParams: OutreachRequestParams;
    isLoading: boolean;
}

export type Props = StateProps & DispatchProps & PaginationWrapperProps & RouteComponentProps<any>;

const class_ = b.with('events-page');

export default class EventsPage extends Component<Props> {
    public static asyncFetchData({ dispatch, location }: AsyncFetchDataProps) {
        const params = EventsPage.getRequestParams(location);

        dispatch(fetchEvents(params));
        dispatch(fetchEventsFilters());
    }

    public static getRequestParams(location: Location, page = 1): OutreachRequestParams {
        const query = parseQuery(location.search);
        const year = query.get('year');
        const params: OutreachRequestParams = { page };

        if (year) {
            params.year = parseInt(year, 10);
        }

        return params;
    }

    public componentDidMount() {
        const { rows, years, location, listParams } = this.props;
        const currentParams = EventsPage.getRequestParams(location);

        if (!rows.length || (listParams.year !== currentParams.year)) {
            this.fetchEvents();
        }

        if (!years.length) {
            this.props.fetchFilters();
        }
    }

    public fetchEvents(params: OutreachRequestParams = {}) {
        const { location } = this.props;
        const currentParams = EventsPage.getRequestParams(location);

        this.props.fetchEvents({ ...currentParams, ...params });
    }

    public onShowMoreClick = () => {
        const { meta } = this.props;
        const { pageNumber } = meta;

        this.fetchEvents({ page: 1 + pageNumber });
    };

    public onYearChange = (year: number | undefined) => {
        const query = formatQuery({ year });

        this.fetchEvents({ year });
        this.props.history.push(`/outreach/events${query}`);
    };

    public renderList() {
        const { rows, hasMore } = this.props;

        return (
            <div className={class_('list')} key="list">
                {rows.map(event =>
                    <EventItem
                        type="horizontal"
                        key={event.id}
                        entity={event}
                    />
                )}
                {hasMore && (
                    <ShowMore onClick={this.onShowMoreClick} />
                )}
            </div>
        );
    }

    public render() {
        const { years, rows, isLoading, location } = this.props;
        const breadcrumbs = [
            { text: 'Outreach', url: '/outreach' },
            { text: 'All events' }
        ];
        const query = parseQuery(location.search);
        const year = query.get('year') || undefined;

        return (
            <div className={class_()}>
                <Breadcrumbs items={breadcrumbs} hideHome />
                <PageMeta title="Events" description={outreachConfig.meta.description} />
                <div className={class_('top')}>
                    <h1 className="block__title">
                        Events
                    </h1>
                    {years.length > 1 && (
                        <YearFilter
                            years={years}
                            selectedYear={year}
                            onYearChange={this.onYearChange}
                        />
                    )}
                </div>

                {isLoading && !rows.length
                    ? <EventsPageStub key="stub" />
                    : this.renderList()
                }
            </div>
        );
    }
}
